export default __webpack_public_path__ + "static/media/whitearrow.f0b008b7.svg";